export const resourceEditErrorKey = (resourceKey) =>
  `resourceedit-${resourceKey}`

export const dashboardErrorKey = "dashboard"

export const templateErrorKey = "template"

export const exportsErrorKey = "exports"

export const signInErrorKey = "signin"

export const searchQARetrieveErrorKey = "searchqaresource"

export const searchErrorKey = "search"

export const metricsErrorKey = "metrics"
